import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*
npr u izradi

- 

TODO:
- 

*/


export const draftel_codecs_pack_terkk$_bundle_npr = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_npr.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_npr',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$npr"), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input

    npr_tipkomore: null,
    // spratna
    npr_sirinakomore: null,
    npr_visinadonjesekcije_preporucena: null,
    npr_visinadonjesekcije: null,
    npr_visinagornjesekcije_preporucena: null,
    npr_visinagornjesekcije: null,
    // bok uz bok
    npr_visinakomore: null,
    npr_sirinaprednjesekcije_preporucena: null,
    npr_sirinaprednjesekcije: null,
    npr_sirinazadnjesekcije_preporucena: null,
    npr_sirinazadnjesekcije: null,

    npr_brojmodula: null,
    npr_duzinasekcijespoljasnjamera: null,
    npr_stranicarekuperatora: null,
    npr_demperbypass: null,

    kolicina: 1,

    // materijali
    npr_materijal_lim_tanji: null,
    npr_materijal_lim_deblji: null
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_npr.default_pods_input_state = () => {
  /*
  return {

  };
  */
  return default_pods_input_state_smart_get('terkk$npr');
};


draftel_codecs_pack_terkk$_bundle_npr.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_npr_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default


    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_npr.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 

  ...Object.keys(draftel_codecs_pack_terkk$_bundle_npr.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_npr.default_subform_item_preset_state())
];


/////////


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------




// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING

